import { isWechat } from '@/common/util/global';
import { Toast } from 'mint-ui';
import fetch from '@/common/util/fetch';
import { request } from '@/common/util/request';

let urls = {
    wxauth: '/insightH5/h5/oauth',
    wxtoken: '/insightH5/h5/jsApi',
    wxauth21Days: '/i/day21/api/oauth',
    wxtoken21Days: '/i/day21/api/jsapi'
};

let actions = {
    wxUserAuth: (context, data) => {
        if (isWechat) {
            // wx 走授权
            let callback = data.callback_url ? encodeURIComponent(data.callback_url) : '';
            location.href = urls.wxauth + '?callbackUrl=' + callback;
        } else {
            return;
        }
    },
    wxToken: (context, data) => {
        if (!data || !data.url) {
            data = {
                url: window.location.href || ''
            }
        }
        if (isWechat) {
            // wx 走授权
            return fetch({
                'url': urls.wxtoken,
                'params': data ? data : {}
            }).then((result) => {
                let data = result.data ? result.data : {};
                // data 判断
                context.commit('wxTokenMutation', data);
                return result;
            }).catch((error) => {
                Toast('页面暂时无法访问，请稍后重试！');
            })
        } else {
            return;
        }
    },
    wxUserAuth21Days: (context, data) => {
        if (isWechat) {
            // wx 走授权
            let callback = data.callback_url ? encodeURIComponent(data.callback_url) : '';
            location.href = '/i/day21/api/oauth?callback_url=' + callback;
        } else {
            return;
        }
    },
    wxtoken21Days: (context, data) => {
        if (isWechat) {
            // wx 走授权
            return request({
                'url': urls.wxtoken21Days,
                'params': data ? data : {}
            }).then((result) => {
                let data = result.data ? result.data : {};
                // data 判断
                context.commit('wxtoken21DaysMutation', data);
                return result;
            }).catch((error) => {
                Toast('页面暂时无法访问，请稍后重试！');
            })
        } else {
            return;
        }
    },
    wxTokenMiniapp: (context, data) => {
        context.commit('wxtokenMiniappMutation', data);
    }
}
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/wxAuth/actions.js